<p-fieldset class="title-legend" [legend]="legend">
    <div class="formgrid grid m-0 p-fluid">
        <div class="field col-4 md:col-2 lg:col-2">
            <input [(ngModel)]="codigoServico" type="text" placeholder="Código" pInputText (input)="buscarServicoCodigo()" />
        </div>
        <div class="field col-8 md:col-5 lg:col-6">
            <app-table-select
                [(ngModel)]="servicoSelecionado"
                (ngModelChange)="onServicoSelecionadoChange()"
                [suggestions]="comboOutrosServicosFiltrado"
                [columns]="colunasServicos"
                optionLabel="descricao"
                (completeMethod)="filterAutoComplete($event)"
                [loading]="loadingServicos"
                [delay]="500"
                placeholder="Digite para pesquisar..."
                searchPlaceholder="Buscar por Descrição do Produto..."
                dialogHeader="Pesquisar Produtos"
                emptyMessage="Nenhum registro encontrado"
                [showClear]="true"
                [style]="{'width':'100%'}">
            </app-table-select>
        </div>

        <div class="field col-4 md:col-1 lg:col-1">
            <!-- <input numbersOnly type="text" [(ngModel)]="quantidadeAdd" pInputText class="text-sm text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"> -->
            <p-inputNumber class="p-inputtext-sm" [(ngModel)]="quantidadeAdd" [min]="1" placeholder="Qty."> </p-inputNumber>
        </div>

        <div class="field col-6 md:col-3 lg:col-2">
            <p-dropdown  class="p-inputtext-sm"  
                emptyMessage="Nenhum registro encontrado" 
                [options]="[{ label: 'Direito', value: 'D'}, { label: 'Esquerdo', value: 'E' }]" 
                [(ngModel)]="olhoServico" 
                [disabled]="olhoDesabilitado" 
                placeholder="Olho" 
                optionLabel="label" [showClear]="true"
                [style]="{width:'100%'}">
            </p-dropdown> 
        </div>

        <div class="field col-2 md:col-1 lg:col-1">
            <p-button icon="pi pi-plus" [rounded]="true" [text]="true" severity="info " (click)="adicionarServico();"></p-button>
        </div>
    </div>
</p-fieldset>